import { useQuery } from '@tanstack/react-query';
import { pipelineNodeService, getBuildTree } from '../services/pipelineNode.service';
import type { ListRecordsResponse, PipelineNode, BuildTreeResponse, BuildTreeOptions } from '../services/pipelineNode.service';

export function usePipelineNodes(options?: {
  page?: number;
  pageSize?: number;
  filters?: Record<string, any>;
  search?: string;
  enabled?: boolean;
}) {
  const {
    page = 1,
    pageSize = 50,
    filters = {},
    search = '',
    enabled = true,
  } = options || {};

  return useQuery<ListRecordsResponse<PipelineNode>>({
    queryKey: ['pipeline-nodes', page, pageSize, filters, search],
    queryFn: () => pipelineNodeService.find({ page, pageSize, filters, search }),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useBuildTree(options?: {
  enabled?: boolean;
  includeDimensions?: boolean;
  includeMeasures?: boolean;
  includeAnalyses?: boolean;
  includeDashboards?: boolean;
}) {
  const {
    enabled = true,
    includeDimensions = false,
    includeMeasures = false,
    includeAnalyses = false,
    includeDashboards = false,
  } = options || {};

  const buildTreeOptions: BuildTreeOptions = {
    includeDimensions,
    includeMeasures,
    includeAnalyses,
    includeDashboards,
  };

  return useQuery<BuildTreeResponse>({
    queryKey: ['pipeline-nodes-build-tree', buildTreeOptions],
    queryFn: () => getBuildTree(buildTreeOptions),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

